import { configureStore, type Reducer } from '@reduxjs/toolkit'
import { sessionReducer } from '@/platform/session/sessionSlice'
import { createReducerManager } from './reducerManager'

const reducerManager = createReducerManager({ session: sessionReducer })

export const store = configureStore({ reducer: reducerManager.reduce })

export function injectReducer(key: string, reducer: Reducer): void {
  if (reducerManager.has(key)) return
  reducerManager.add(key, reducer)
  store.replaceReducer(reducerManager.reduce)
}

export type AppState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
